import AccordionFAQ from 'accordion-js';

new AccordionFAQ('.faq-list-one',  {
  duration: 400,
  showMultiple: true,
});
  
new AccordionFAQ('.faq-list-two', {
  duration: 400,
  showMultiple: true,
});
  